module.exports = __webpack_public_path__ + "static/media/MMG Import Template.9aee7e4b.xlsm";